export default __webpack_public_path__ + "assets/images/4d0c9aff7dbf86c35024c311619e8f27.png";